import React, {useEffect, useRef, useState} from "react";


const InfoSection = () =>{
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);

        return () => {
            if (sectionRef.current) observer.unobserve(sectionRef.current);
        };
    }, []);
    return (
        <section className="py-5" ref={sectionRef} id="chisiamo">
            <div className="container">
                <div className="row g-4 text-center">
                    <div className="col-md-12 p-3">
                        <div className={`box-rounded h-100 slide-down ${visible ? 'visible' : ''}`}>
                            <span className="pt-5" style={{'color' : '#835d5d', 'font-size' : '50px', fontWeight : 600}}>Chi NON Siamo</span>
                            <h4 className="p-5">Non vogliamo venderci per quello che non siamo: non siamo psicologi, psicoterapeuti o simili; non è il posto per te se hai bisogno di un supporto medico o di aiuto, se sei vittima di violenza o abusi.
                                A volte è più facile parlare con qualcuno che non ci conosce: la riservatezza è la nostra parola d’ordine, puoi interagire con noi tramite uno username.
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
)
}

export default InfoSection;
